import React, { useRef } from 'react';
import { useDispatch } from 'react-redux';
import PropTypes from 'prop-types';

// State
import { toggleHomeCatalog } from '../../state/modules/ui/actions';

export default function CategoryNavItem(props) {
  const { alias, role, tabIndex, className, children } = props;

  const dispatch = useDispatch();
  const elementRef = useRef(null);

  const handleScroll = () => {
    elementRef.current = document.querySelector(`#${alias}`);

    if (!elementRef.current) {
      return;
    }

    dispatch(toggleHomeCatalog(false));
    setTimeout(() => {
      window.scrollBy({
        top: elementRef.current.getBoundingClientRect().top - 75,
        behavior: 'instant',
      });
      dispatch(toggleHomeCatalog(true));
    }, 300);
  };

  return (
    <span
      role={role}
      tabIndex={tabIndex}
      onClick={handleScroll}
      className={className}
      onKeyPress={e => e.key === 'Enter' && handleScroll()}
    >
      {children}
    </span>
  );
}

CategoryNavItem.defaultProps = {
  className: '',
  tabIndex: 0,
  children: null,
};

CategoryNavItem.propTypes = {
  alias: PropTypes.string.isRequired,
  role: PropTypes.string.isRequired,
  className: PropTypes.string,
  children: PropTypes.node,
  tabIndex: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
};
